import { useEffect, useMemo, useState } from 'react';
import { getPhysicalStoresCount } from '@/shared/features/store-count/application/services/storeCountService';

export function useStoreCount(fallback?: number | string) {
  const fallbackNumber = useMemo(() => {
    if (typeof fallback === 'number' && Number.isFinite(fallback)) return fallback;
    if (typeof fallback === 'string') {
      const match = fallback.match(/\d+/);
      if (match) {
        const n = Number(match[0]);
        if (Number.isFinite(n)) return n;
      }
    }
    return null;
  }, [fallback]);

  const [storeCount, setStoreCount] = useState<number | null>(fallbackNumber);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<unknown>(undefined);

  useEffect(() => {
    let cancelled = false;

    getPhysicalStoresCount()
      .then((count) => {
        if (cancelled) return;
        setError(undefined);
        if (typeof count === 'number') setStoreCount(count);
        else setStoreCount(fallbackNumber);
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e);
        setStoreCount(fallbackNumber);
      })
      .finally(() => {
        if (cancelled) return;
        setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [fallbackNumber]);

  return {
    storeCount,
    isLoading,
    error,
  };
}

